import { SupportedLanguage, supportedLanguages } from '../lib/i18n';

/**
 * Detects language preference from URL parameters or sessionStorage
 * Priority: URL param > sessionStorage > null
 * @returns The detected language code or null if not found
 */
export function detectLanguageFromMarketing(): SupportedLanguage | null {
  // 1. Check URL query parameter first (highest priority)
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  
  if (langParam) {
    const lang = langParam.toLowerCase() as SupportedLanguage;
    if (supportedLanguages.some(l => l.code === lang)) {
      // Remove the lang parameter from URL to clean it up
      urlParams.delete('lang');
      const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '');
      window.history.replaceState({}, '', newUrl);
      return lang;
    }
  }
  
  // 2. Check sessionStorage (set by marketing site)
  try {
    const marketingLang = sessionStorage.getItem('marketing_language');
    if (marketingLang) {
      const lang = marketingLang.toLowerCase() as SupportedLanguage;
      if (supportedLanguages.some(l => l.code === lang)) {
        // Optionally clear it after reading (or keep it for consistency)
        // sessionStorage.removeItem('marketing_language');
        return lang;
      }
    }
  } catch (error) {
    // sessionStorage might not be available in some contexts
    // console.error('Error reading sessionStorage:', error);
  }
  
  return null;
}

